module.exports = __webpack_public_path__ + "static/media/sustenta.1ec51b9b.png";